import React, { useState, useEffect } from 'react';
import SignaturePad from 'react-signature-canvas';
import { useSelector, useDispatch } from 'react-redux';
import UploadService from 'services/FileUploadService';
import LinearProgress from '@mui/material/LinearProgress';
import Loading from 'app/components/MatxLoading/MatxLoading';
import axios from 'axios';
import {
  Box,
  Typography,
  Button,
  Grid,
  Card,
  CardHeader,
  CardActions,
  IconButton,
  CardContent,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import ReplayIcon from '@mui/icons-material/Replay';
import CheckIcon from '@mui/icons-material/Check';
import {
  increment,
  decrement,
  setFile1Data,
  setFileData,
} from 'actions/counter';
const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 6,
    borderRadius: 5,
  },
  colorPrimary: {
    // #A3E4D7
    // #EEEEEE
    backgroundColor: '#EAFAF1',
  },
  bar: {
    // #1a90ff
    borderRadius: 5,
    backgroundColor: '#7DCEA0',
  },
}))(LinearProgress);
const SignPad = (props) => {
  const { user: currentUser } = useSelector((state) => state.auth);
  const {
    counter: { cnt, file1Data, fileData },
  } = useSelector((state) => state.counter);
  const dispatch = useDispatch();
  const { rhf, control, msg1, formikName, uid, rdxFileData, rdxSetFileData } =
    props;
  const [dataURL, setDataURL] = useState({ trimmedDataURL: null });
  const [sigPad, setSigPad] = useState(null);
  const [currentFile, setCurrentFile] = useState(undefined);
  const [progress, setProgress] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');

  // ดึงลายเซ็นจาก API เมื่อ uid เปลี่ยน
  useEffect(() => {
    const fetchSignature = async () => {
      // Clear state เมื่อ uid เปลี่ยน
      setDataURL({ trimmedDataURL: null });

      if (uid) {
        try {
          console.log('SignaturePad - Fetching signature for uid:', uid);
          const { data } = await axios.get(`/api/signupload/${uid}`);
          console.log('SignaturePad - Response data:', data);
          if (data?.data && data?.name) {
            console.log('SignaturePad - Filename:', data.name);
            // แสดงเฉพาะลายเซ็นบนเว็บ (signpad)
            if (data.name.startsWith('signpad')) {
              const buffer = Buffer.from(data.data, 'base64');
              const dataImagePrefix = `data:image/png;base64,`;
              const signImgUrl = `${dataImagePrefix}${buffer.toString('base64')}`;
              setDataURL({ trimmedDataURL: signImgUrl });
              console.log('SignaturePad - Loaded signpad signature');
            } else {
              console.log(
                'SignaturePad - Skipped uploaded image (belongs to SignatureUpload tab)',
              );
            }
          } else {
            console.log('SignaturePad - No signature found');
          }
        } catch (error) {
          console.log('SignaturePad - Error fetching signature:', error);
          setDataURL({ trimmedDataURL: null });
        }
      }
    };
    fetchSignature();
  }, [uid]);

  const clear = () => {
    // Clear canvas
    if (sigPad && typeof sigPad.clear === 'function') {
      sigPad.clear();
    }
    // Clear preview image
    setDataURL({ trimmedDataURL: null });
  };
  const trim = () => {
    console.log(sigPad.getTrimmedCanvas());
    setDataURL({
      trimmedDataURL: sigPad.getTrimmedCanvas().toDataURL('image/png'),
    });
  };

  const base64ToBlob = (base64, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  };
  const onSubmit = () => {
    const blob = base64ToBlob(
      dataURL.trimmedDataURL.split(';base64,').pop(),
      'image/png',
    );
    const file = new File(
      [blob],
      'signpad_' + Math.random().toString(36).substring(7) + '.png',
      {
        type: 'image/png',
      },
    );

    setCurrentFile(file);
    setProgress(0);
    setIsLoading(true);

    UploadService.uploadSignPad(
      file,
      currentUser.username,
      uid,
      formikName,
      (event) => {
        setProgress(Math.round((100 * event.loaded) / event.total));
      },
    ).then((response) => {
      console.log('res', response);
      setDataURL({
        trimmedDataURL: response?.data.data,
      });
      setIsLoading(false);
      setMessage(response.data.message);
      dispatch(
        setFileData({
          docType: formikName,
          name: response.data.name,
          url: response.data.url,
          data: response.data.data,
          type: response.data.type,
        }),
      );
    });
  };

  const bufferToBase64 = (blob) => {
    console.log('blob', blob);
    const dataImagePrefix = `data:image/png;base64,`;
    const buffer = new Buffer.from(blob, 'base64');
    return `${dataImagePrefix}${buffer.toString('base64')}`;
  };

  const getBase64ByDocType = async (fileData) => {
    const tmp = fileData.find((el) => el.docType == formikName);
    const dataImagePrefix = `data:image/png;base64,`;
    if (tmp?.data != undefined && tmp?.name.includes('signpad')) {
      const buffer = new Buffer.from(tmp?.data, 'base64');
      setDataURL({
        trimmedDataURL: `${dataImagePrefix}${buffer.toString('base64')}`,
      });
    }
  };

  //convert img data to base64
  useEffect(() => {
    getBase64ByDocType(fileData);
  }, [fileData]);
  return (
    <Box sx={{ flexGrow: 1 }}>
      {currentFile ? (
        <Box display="flex" alignItems="center">
          <Box width="100%" mr={1}>
            <BorderLinearProgress variant="determinate" value={progress} />
          </Box>
          <Box minWidth={35}>
            <Typography
              variant="body2"
              color="textSecondary"
            >{`${progress}%`}</Typography>
          </Box>
        </Box>
      ) : (
        <Typography variant="caption" component="div" color="#1e88e5">
          {msg1}
        </Typography>
      )}

      <Grid container spacing={2} justifyContent="flex-start">
        <Grid item xs={12}>
          <Card>
            <CardHeader
              style={{
                backgroundColor: 'rgba(0,0,0,.03)',
                borderBottom: '1px solid rgba(0,0,0,.125)',
                padding: '0.75rem 1.25rem',
                marginBottom: 0,
              }}
              title={
                <Typography variant="body2" color="red">
                  *โปรดกดเครื่องหมาย ✔ และกด Submit เพื่อให้ลายเซ็นเข้าระบบ
                </Typography>
              }
              action={
                <>
                  {/* <Button onClick={clear}>Clear</Button>
                                    <Button onClick={trim}>Trim</Button> */}

                  <IconButton aria-label="clear" onClick={clear}>
                    <ReplayIcon />
                  </IconButton>
                  <IconButton aria-label="ok" onClick={trim}>
                    <CheckIcon />
                  </IconButton>
                </>
              }
            />
            {isLoading ? (
              <>
                <CardContent>
                  {/* <div>removing..</div> */}
                  <Loading />
                </CardContent>
              </>
            ) : (
              <CardContent>
                <SignaturePad
                  // backgroundColor="#E2E8F0"
                  canvasProps={{
                    height: 200,
                    width: 500,
                    borderRadius: '2px',
                    border: '1px',
                    borderColor: 'black.200',
                  }}
                  ref={(ref) => {
                    setSigPad(ref);
                  }}
                />
              </CardContent>
            )}
            {dataURL.trimmedDataURL && !isLoading && (
              <>
                <CardContent
                  style={{ borderTop: '1px solid rgba(0,0,0,.125)' }}
                >
                  <img mt={4} src={dataURL.trimmedDataURL}></img>
                </CardContent>
                <CardActions>
                  <Button size="small" color="primary" onClick={onSubmit}>
                    Submit
                  </Button>
                </CardActions>
              </>
            )}
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SignPad;
